import React, { useRef, useState } from "react";
import api from "../api/axios";
import type { IFileUploadProps } from "../pages/first-line/ChatForm.interface";

export const FileUpload: React.FC<IFileUploadProps> = ({ leadId }) => {
  const [file, setFile] = useState<File | null>(null);
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState("");
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      setFile(e.target.files[0]);
    }
  };

  const handleChooseFile = () => {
    fileInputRef.current?.click();
  };

  const handleUpload = async () => {
    if (!file) {
      setMessage("Файл не выбран");
      return;
    }

    const originalName = file.name;

    const safeName = encodeURIComponent(originalName);

    const fixedFile = new File([file], safeName, { type: file.type });

    const formData = new FormData();
    formData.append("file", fixedFile);
    formData.append("leadId", String(leadId));

    try {
      setUploading(true);
      setMessage("");

      const response = await api.post(`/api-gateway/upload-file`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      setMessage("Файл успешно загружен!");
      console.log(response.data);
    } catch (error) {
      setMessage("Ошибка при загрузке файла");
      console.error(error);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="file-uploader">
      <input type="file" ref={fileInputRef} onChange={handleFileChange} />
      <label>{file ? file.name : "Выберите файл"}</label>
      <button onClick={handleChooseFile}>Выбрать файл</button>
      <button onClick={handleUpload} disabled={!file || uploading}>
        {uploading ? "Загружается..." : "Отправить"}
      </button>
      {message && <p>{message}</p>}
    </div>
  );
};
